// Import the functions you need from the SDKs you need
import { getAnalytics } from 'firebase/analytics';
import { initializeApp } from 'firebase/app';
import { browserLocalPersistence, getAuth, setPersistence } from 'firebase/auth';

const firebaseConfig =
  import.meta.env.MODE === 'production'
    ? {
        apiKey: 'AIzaSyDPUd0toK5Cu8g8BwnPv6oyQWecuVLywUU',
        authDomain: 'twig-products.firebaseapp.com',
        projectId: 'twig-products',
        storageBucket: 'twig-products.firebasestorage.app',
        messagingSenderId: '1060152539087',
        appId: '1:1060152539087:web:3a46cdfdc5b507e41a84ba',
        measurementId: 'G-GP3RT7M4NX',
      }
    : {
        apiKey: 'AIzaSyABISXO0HZeszs7vLidqqXTA02TLAztvoQ',
        authDomain: 'twig-io-test.firebaseapp.com',
        projectId: 'twig-io-test',
        storageBucket: 'twig-io-test.firebasestorage.app',
        messagingSenderId: '480424561858',
        appId: '1:480424561858:web:cf06c22a1549fa43a23f5b',
      };

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const auth = getAuth(app);

// Check for impersonation param and store in sessionStorage
const params = new URLSearchParams(window.location.search);
const impersonateUid = params.get('impersonate');
if (impersonateUid) {
  sessionStorage.setItem('impersonate', impersonateUid);
  // Remove from URL
  params.delete('impersonate');
  const newUrl = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
  window.history.replaceState({}, '', newUrl);
}

// Always use local persistence (admin stays logged in)
setPersistence(auth, browserLocalPersistence);
